const questions = [
  {
    question: "The most important thing when making decisions in a project is:",
    answers: ["focus on the goal", "creating a unique idea"],
    colors: ["R", "Y"],
  },
  {
    question: "During the task implemetation, the most important thing is to:",
    answers: [
      "work in a thoughtful way",
      "help the weakest employees",
    ],
    colors: ["B", "G"],
  },
  {
    question: "In team communication:",
    answers: ["be at ease, joke around", "take care not to offend anyone"],
    colors: ["Y", "G"],
  },
  {
    question: "During professional meetings:",
    answers: [
      "first I try to analyze the situation well",
      "first I build a relationship, then I try to go into business",
    ],
    colors: ["B", "Y"],
  },
  {
    question: "When I give feedback:",
    answers: [
      "I take care not to hurt anybody",
      "I try to be clearly understood",
    ],
    colors: ["G", "B"],
  },
  {
    question: "When someone is late:",
    answers: [
      "I am calmly waiting for the rationale",
      "I do not tolerate being late",
    ],
    colors: ["B", "R"],
  },
  {
    question: "In teamwork:",
    answers: ["the most important thing is effectiveness", "the most important thing is to implement the strategy"],
    colors: ["R", "B"],
  },
  {
    question: "The role of the boss is:",
    answers: ["achieving goals at any cost", "protecting team members"],
    colors: ["R", "G"],
  },
  {
    question: "When I get a new assignment:",
    answers: [
      "I plan them carefully",
      "I am excited as if embarking on an adventure",
    ],
    colors: ["B", "Y"],
  },
  {
    question: "When someone is rude to me:",
    answers: ["I say directly what I think", "I react in a controlled manner"],
    colors: ["R", "B"],
  },
  {
    question: "After completing a task, I am more satisfied with:",
    answers: [
      "the experience of it and an opportunity of sharing it with others",
      "the fact that the next task is already completed",
    ],
    colors: ["Y", "R"],
  },
  {
    question: "I prefer a lecturer who is:",
    answers: ["dry but logical", "distracted but lovable"],
    colors: ["B", "G"],
  },
  {
    question: "I have the best rest:",
    answers: [
      "alone or in a small group",
      "when I am active, breaking another record or taking part in a competition",
    ],
    colors: ["G", "R"],
  },
  {
    question: "They annoy me more:",
    answers: [
      "realists for whom only “here and now” counts",
      "rationalists who want to put everything into procedures",
    ],
    colors: ["G", "Y"],
  },
  {
    question: "When in  a company of others, I usually:",
    answers: ["speak more than the rest", "I express myself  succinctly and to the point"],
    colors: ["Y", "R"],
  },
  {
    question: "I often regret saying:",
    answers: ["not enough", "too much"],
    colors: ["G", "Y"],
  },
  {
    question: "I make decisions often:",
    answers: ["too fast", "too late"],
    colors: ["Y", "B"],
  },
  {
    question: "I believe constructive criticism",
    answers: [
      "is desirable and effective",
      "often hurts and causes great harm",
    ],
    colors: ["R", "G"],
  },
];

export default questions;
